import { render, staticRenderFns } from "./AdminMoneyIcon.vue?vue&type=template&id=54e3ccf0&scoped=true"
var script = {}
import style0 from "./AdminMoneyIcon.vue?vue&type=style&index=0&id=54e3ccf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e3ccf0",
  null
  
)

export default component.exports